<br>
<div class="container">
    <app-user-table [data]="dataSource" [groups]="groups" (changes)="onChanges($event)"></app-user-table>
    <app-tab-manager 
    [Tabs]="Tabs.controls" 
    [Email]="emailList"
    [Defaults]="Defaults" 
    (changes)="onTabChanges($event)" 
    (delete)="onTabDelete($event)"></app-tab-manager>
</div>


